import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from '../api/session';

/** Everything except `/login` needs a staff session; without one, go to the login page and come back. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const session = useSession();
  const { pathname, search, hash } = useLocation();
  if (!session) return <Navigate to={`/login?next=${encodeURIComponent(pathname + search + hash)}`} replace />;
  return children;
}
